import config from 'config';

import { fetchQrCodeUrl as fetchQrCodeUrlApi } from 'support/api/QRCodeApi';
import { HttpClient } from 'support/api/api-types';

export const QR_CODE = 'QR_CODE' as const;

export const fetchShortCodeQrCode = (url: string, shortCode: string) => {
  const data = {
    type: 'url',
    urldata: `${url}/${shortCode}`,
  };

  return {
    type: QR_CODE,
    promise: (httpClient: HttpClient) => fetchQrCodeUrlApi(httpClient, data),
  };
};

export const fetchContactUsQrCode = (subject: string, body: string) => {
  const data = {
    type: 'email',
    email: config.contactEmail,
    subject,
    body,
  };
  return {
    type: QR_CODE,
    promise: (httpClient: HttpClient) => fetchQrCodeUrlApi(httpClient, data),
  };
};
